export default {
  settings: {
    title: "Налаштування",
    form: {
      fastRun: "Швидкий запуск",
      fastRunOptions: {
        classic: "Класичний",
        basic: "Базовий",
        user: "Користувальницький"
      }
    },
    notify: {
      title: "Швидкий запуск",
      message: "Налаштування успішно збережено"
    }
  }
};
